import _ from 'lodash';
import api from '../../api';
import environment from '../../environment';
import translate from '../../core/tools/translate';

const LayerControls = (name) => require('../../controls/index').get(name);

class ServiceAreaAction {
    constructor ({ feature, layer, currentMap, name }) {
        const turnOnServiceArea = () => {
            if (!LayerControls('ServiceArea').check()) { LayerControls('ServiceArea').check(true); }

            api.general.log.action(environment._getContextEnum(name), 'Loja - Service Area', JSON.stringify(feature.properties));
            LayerControls('ServiceArea').add(feature, currentMap, name);
        };

        const turnOffServiceArea = () => LayerControls('ServiceArea').remove(feature, currentMap);

        return {
            check: () => this._isSelected(feature, LayerControls('ServiceArea').getLayer(currentMap), currentMap),
            layer,
            map: currentMap,
            icon: 'icon_bubble_tradearea',
            title: translate('Action.StoreAreas'),
            off: turnOffServiceArea,
            on: turnOnServiceArea
        };
    }

    _isSelected (feature, layer, currentMap) {
        if (!currentMap.hasLayer(layer)) { return false; }
        return !!_.find(layer.getFeatures(), f => f.properties.IdLoja === feature.properties.Id);
    }
}

export default ServiceAreaAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/ServiceAreaAction.js